export const formatCNPJ = (cnpj) => {
    // Se o CNPJ for nulo, indefinido ou vazio, retorna um traço
    if (!cnpj || cnpj.toString().trim() === '') {
        return '-';
    }
    
    // Converte para string e remove espaços
    const cnpjStr = cnpj.toString().trim();
    
    // Se já está formatado (contém pontos e barras), retorna como está
    if (cnpjStr.includes('.') && cnpjStr.includes('/')) {
        return cnpjStr;
    }
    
    // Remove todos os caracteres não numéricos
    const numbersOnly = cnpjStr.replace(/\D/g, '');
    
    // Se não tem 14 dígitos, retorna o valor original ou um traço
    if (numbersOnly.length !== 14) {
        return numbersOnly.length > 0 ? numbersOnly : '-';
    }
    
    // Formata o CNPJ: XX.XXX.XXX/XXXX-XX
    return numbersOnly.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
    );
};

// Função para validar se um CNPJ é válido
export const isValidCNPJ = (cnpj) => {
  if (!cnpj || typeof cnpj !== 'string') return false;
  
  const cleanCNPJ = cnpj.replace(/\D/g, '');
  return cleanCNPJ.length === 14;
};

// Função para limpar CNPJ (remover formatação)
export const cleanCNPJ = (cnpj) => {
  if (!cnpj || typeof cnpj !== 'string') return '';
  return cnpj.replace(/\D/g, '');
};